import joaoPaulo from '@/assets/pessoas/joao-paulo.jpg';
import kelly from '@/assets/pessoas/kelly.jpg';
import gustavo from '@/assets/pessoas/gustavo.jpg';
import larissa from '@/assets/pessoas/larissa.jpg';
import silvia from '@/assets/pessoas/silvia.jpg';

/**
 * Quem facilita.
 *
 * Titulacao e biografia saem do roteiro de 19/10, escrito pelo proprio grupo.
 * Nada aqui foi redigido por fora: titulacao de pessoa e dado dela, nao texto
 * de marketing, e errar a de alguem e pior do que nao publicar.
 *
 * O roteiro trazia o LinkedIn da Kelly nas duas aparicoes do Gustavo, por
 * engano de copia. Corrigido em 19/10 com o endereco que ele passou.
 *
 * As cinco fotos existem. Quatro estavam embutidas dentro do proprio
 * Roteiro de ajuste .docx, e so foram encontradas quando o arquivo foi aberto
 * como zip: extrair o texto com textutil nao traz imagem. A da Silvia veio
 * separada, porque ela era a unica sem foto no documento, que e exatamente o
 * que a reuniao de 14/10 registrou.
 *
 * A da Kelly foi trocada em 20/10 por um original de 1079 pixels que ela
 * mandou na revisao. A da Larissa veio com faixas pretas dos dois lados, que
 * o corte quadrado deixava aparecer; foram recortadas no proprio arquivo.
 *
 * RESSALVA DE QUALIDADE. Duas delas (Joao Paulo e Larissa) tem 256 pixels, que e menos do que a
 * tela precisa: o card mostra a 176 pixels, e em tela de alta densidade isso
 * pede 352. Vao aparecer um pouco moles. Se os originais existirem, vale
 * substituir, trocando so o arquivo.
 */
export interface Pessoa {
  nome: string;
  papel: string;
  /** As tres frentes que a pessoa traz, como no roteiro. */
  eixos: string;
  bio: string;
  /** O que ela especificamente acrescenta ao curso. */
  contribuicao: string;
  linkedin: string;
  foto?: string;
  alt?: string;
  /**
   * Onde cortar o quadrado, em object-position. So as fotos em pe precisam:
   * cortado pelo meio, o quadrado pega o peito e decapita. O valor vertical
   * foi medido em cada foto para o rosto ficar um pouco acima do centro.
   */
  enquadramento?: string;
}

export const pessoas: Pessoa[] = [
  {
    nome: 'João Paulo Ripardo',
    papel: 'Coordenador da Imersão HCRM',
    eixos: 'Medicina · Liderança clínica · Gestão em saúde',
    bio: 'Médico cirurgião, gestor em saúde e especialista em Melhoria pelo Institute for Healthcare Improvement (IHI). Possui experiência em medicina de emergência, trauma e gestão de operações hospitalares, com atuação na liderança de equipes, integração de processos assistenciais e desenvolvimento de iniciativas voltadas à segurança do paciente.',
    contribuicao:
      'Traz para o HCRM a perspectiva da liderança clínica e da tomada de decisão em ambientes críticos, conectando fatores humanos, gestão e desempenho das equipes.',
    linkedin: 'https://www.linkedin.com/in/jo%C3%A3o-paulo-ripardo-1867607a/',
    foto: joaoPaulo,
    alt: 'Retrato de João Paulo Ripardo, em preto e branco.',
  },
  {
    nome: 'Kelly Santana',
    papel: 'Vice-coordenadora da Imersão HCRM',
    eixos: 'Farmácia · Segurança do Paciente · Qualidade e Melhoria',
    bio: 'Farmacêutica, especialista em Qualidade em Saúde, Segurança do Paciente e em Melhoria pelo Institute for Healthcare Improvement (IHI). Coordenadora da Gestão da Qualidade e Riscos do Instituto Central do HCFMUSP e avaliadora ONA, possui mais de 15 anos de experiência em qualidade, gestão de riscos e melhoria de processos em instituições de saúde de alta\u00a0complexidade.',
    contribuicao:
      'Contribui com a perspectiva da segurança do paciente, da cultura organizacional e da implementação de práticas que fortaleçam a confiabilidade dos processos assistenciais.',
    linkedin: 'https://www.linkedin.com/in/kelly-santana-0096a02a/',
    foto: kelly,
    alt: 'Retrato de Kelly Santana, de blazer escuro.',
    enquadramento: '50% 25%',
  },
  {
    nome: 'Gustavo Fernandes Moreira',
    papel: 'Facilitador da Imersão HCRM',
    eixos: 'Medicina de emergência · Gestão de equipes · Simulação realística',
    bio: 'Médico emergencista, especialista em Medicina de Emergência e MBA em Gestão em Saúde. Possui experiência na liderança de departamentos de emergência de alta complexidade, gestão de equipes multidisciplinares, implantação de protocolos assistenciais e melhoria de processos.',
    contribuicao:
      'Atua na formação de profissionais de saúde e como facilitador de treinamentos em simulação realística. Sua contribuição está na aplicação prática da liderança, da coordenação de equipes e da tomada de decisão sob pressão.',
    linkedin: 'https://www.linkedin.com/in/gustavofm',
    foto: gustavo,
    alt: 'Retrato de Gustavo Fernandes Moreira, de terno escuro.',
    enquadramento: '50% 4%',
  },
  {
    nome: 'Larissa Carvalho',
    papel: 'Facilitadora da Imersão HCRM',
    eixos: 'Fatores humanos · Segurança operacional · Aviação',
    bio: 'Profissional com experiência no setor aeronáutico e formação complementar em fatores humanos, gerenciamento de riscos, segurança operacional, prevenção e investigação de acidentes aeronáuticos.',
    contribuicao:
      'Contribui com a perspectiva dos fatores humanos em sistemas complexos e de alto risco, ampliando a compreensão sobre comportamento, comunicação, consciência situacional e tomada de decisão, princípios desenvolvidos na aviação que inspiraram a evolução do CRM e sua adaptação à saúde.',
    linkedin: 'https://www.linkedin.com/in/larissa-carvalho-2820a734/',
    foto: larissa,
    alt: 'Retrato de Larissa Carvalho, sentada dentro de uma aeronave.',
    enquadramento: '50% 8%',
  },
  {
    nome: 'Silvia Vieira',
    papel: 'Facilitadora da Imersão HCRM',
    eixos: 'Enfermagem · Liderança · Gestão assistencial',
    bio: 'Enfermeira, mestre em Saúde do Adulto pela Escola de Enfermagem da Universidade de São Paulo (USP), com experiência em gestão assistencial, liderança de equipes e organização de serviços de saúde. Sua trajetória inclui atuação em instituições hospitalares e participação em iniciativas de desenvolvimento profissional e integração multiprofissional.',
    contribuicao:
      'Traz a perspectiva da enfermagem e da gestão do cuidado, contribuindo para a discussão sobre comunicação, coordenação entre profissionais e construção de equipes mais seguras e colaborativas.',
    linkedin: 'https://www.linkedin.com/in/silvia-vieira-78ba1b7a/',
    foto: silvia,
    alt: 'Retrato de Silvia Vieira, de jaleco branco.',
    enquadramento: '50% 21%',
  },
];

/** A abertura e o fecho do bloco, que explicam por que o corpo e misturado. */
export const corpoDocente = {
  abertura: 'HCRM se aprende com diferentes perspectivas.',
  texto:
    'Um corpo de facilitadores multiprofissional, como as equipes que precisam funcionar juntas todos os dias. Medicina, enfermagem, farmácia, gestão, qualidade e fatores humanos reunidos em torno de um mesmo propósito: desenvolver equipes capazes de se comunicar, liderar, tomar decisões e atuar de forma coordenada em ambientes complexos e de alta pressão.',
  tituloDoFecho: 'Diferentes trajetórias. Um propósito comum.',
  fecho:
    'A Imersão reúne profissionais com experiências complementares em assistência, liderança, gestão, segurança do paciente e fatores humanos. Essa diversidade permite discutir os desafios do trabalho em equipe sob diferentes perspectivas: de quem toma decisões clínicas, de quem coordena o cuidado, de quem gerencia riscos e processos e de quem estuda o comportamento humano em sistemas de alta\u00a0complexidade.',
  remate:
    'Porque a segurança não depende apenas de bons profissionais. Depende também de como bons profissionais trabalham juntos.',
} as const;
